import { convertProductNameToUrl, ProductHit, ProductName } from 'helpers/algolia/map-product';
import { Hit } from 'instantsearch.js';

export const productUrl = (productHit: Hit<ProductHit>, locale: string) => {
  let url;
  const lvl = (productHit?.categories as any)?.[locale?.replace('_', '-')]?.lvl0;

  const selectedCategory =
    lvl?.find((cat: string) => !cat?.includes('BRANDS')) ?? lvl?.find((cat: string) => cat?.includes('BRANDS'));

  let finalCategory;
  // as of now we are hard coded the "All Products" category need to optimise later

  if (selectedCategory?.split(' > ')[0] === 'All Products') {
    finalCategory = 'products';
  } else {
    finalCategory = !selectedCategory?.split(' > ')?.[0] ? 'products' : selectedCategory?.split(' > ')?.[0];
  }
  return (url =
    '/' +
    finalCategory?.toLowerCase()?.replace(' ', '-') +
    '/' +
    convertProductNameToUrl((productHit?.name as ProductName)?.[locale?.replace('_', '-')]) +
    (productHit?.slug as any)?.[locale?.replace('_', '-')] +
    '.html');
};
